"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageTrackingClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const _ = require("lodash");
const PackageTrackingErrorCode_1 = require("./PackageTrackingErrorCode");
const defaultPackageTrackingClientConfig = {
    serviceUrl: process.env.PACKAGE_TRACKING_SERVICE_URL,
    basicAuthUser: process.env.PACKAGE_TRACKING_BASIC_AUTH_USER,
    basicAuthPassword: process.env.PACKAGE_TRACKING_BASIC_AUTH_PASSWORD,
};
class PackageTrackingClient extends base_client_1.ApiBasicAuthClient {
    constructor(packageTrackingClientConfig = defaultPackageTrackingClientConfig, axiosConfig = {}) {
        const { serviceUrl, basicAuthUser, basicAuthPassword } = packageTrackingClientConfig;
        if (!serviceUrl) {
            throw new Error("PACKAGE_TRACKING_SERVICE_URL environment variable is not set");
        }
        super(Object.assign(Object.assign({}, axiosConfig), { baseURL: `${serviceUrl}/v1`, basicAuthUser,
            basicAuthPassword }));
        if (!basicAuthUser) {
            commons_logs_1.log.warn("The PACKAGE_TRACKING_BASIC_AUTH_USER environment variable was not set.");
        }
        else if (!basicAuthPassword) {
            commons_logs_1.log.warn("The PACKAGE_TRACKING_BASIC_AUTH_PASSWORD environment variable was not set.");
        }
    }
    async savePackageStatus(packageStatus) {
        try {
            return await this.post("package-status", packageStatus);
        }
        catch (err) {
            throw this.getPackageTrackingError("savePackageStatus", err);
        }
    }
    async findPackageStatuses(packageStatus) {
        try {
            return await this.get("package-status", packageStatus);
        }
        catch (err) {
            throw this.getPackageTrackingError("findPackageStatuses", err);
        }
    }
    translateServerError(fn, err) {
        if (err.type === "VALIDATION_ERROR") {
            return new errors_1.DeliverrError({
                code: PackageTrackingErrorCode_1.PackageTrackingErrorCode.VALIDATION_ERR,
                functionName: fn,
                payload: err.details || err,
                message: _.get(err, ["details", 0, "message"]),
            });
        }
    }
    getPackageTrackingError(fn, err) {
        const serverError = _.get(err, ["response", "data", "error"]);
        if (serverError) {
            const translatedError = this.translateServerError(fn, serverError);
            if (translatedError) {
                return translatedError;
            }
        }
        return new errors_1.DeliverrError({
            code: errors_1.ApiError.UNKNOWN_ERROR,
            payload: _.get(err, ["response", "data", "error"]) || err,
            message: _.get(err, "message"),
        });
    }
}
exports.PackageTrackingClient = PackageTrackingClient;
exports.default = PackageTrackingClient;
//# sourceMappingURL=PackageTrackingClient.js.map